import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { findImage } from 'utils/Utils';

const PayverseHeader = ({ logoOn = true }) => {
  const { t, i18n } = useTranslation();

  const handleLanguageChange = event => {
    i18n.changeLanguage(event.target.value);
  };

  return (
    <Header>
      {logoOn && (
        <Logo>
          <Middle>
            <img src={findImage('logo.png')} alt="Logo" />
          </Middle>
        </Logo>
      )}
      <LanguageButton>
        <Middle>
          <LanguageSelect value={i18n.language} onChange={handleLanguageChange}>
            <option value="ko">한국어</option>
            <option value="en">English</option>
            <option value="jp">日本語</option>
            {/* 간체 */}
            <option value="cnsi">中文 （简体字）</option>
            {/* 번체 */}
            <option value="cntr">中文 （繁体字）</option>
          </LanguageSelect>
        </Middle>
      </LanguageButton>
    </Header>
  );
};

// Header 컴포넌트
const Header = styled.header`
  width: 100%;
  height: 60px;
  padding: 0 20px;
  box-sizing: border-box;

  &::after {
    content: '';
    display: table;
    clear: both;
  }

  @media only screen and (max-width: 767px) {
    height: 48px;
    padding: 0 30px;
  }
`;

// Logo 컴포넌트
const Logo = styled.div`
  float: left;
  width: calc(100% - 120px);

  @media only screen and (max-width: 767px) {
    width: calc(100% - 110px);
  }
`;

// Middle 컴포넌트
const Middle = styled.div`
  display: table-cell;
  vertical-align: middle;
  width: 100vw;
  height: 60px;

  img {
    height: 18px;
  }

  @media only screen and (max-width: 767px) {
    height: 48px;

    img {
      height: 14px;
    }
  }
`;

// LanguageButton 컴포넌트
const LanguageButton = styled.div`
  float: right;
  width: 120px;

  @media only screen and (max-width: 767px) {
    width: 110px;
  }
`;

const LanguageSelect = styled.select`
  min-width: 70px;
  width: 120px;
  height: 28px;
  font-size: 11px;
  line-height: 26px;
  color: #163b6a;
  text-align: left;
  background: none;
  border: 1px solid #163b6a;
  border-radius: 5px;
  padding: 0 10px;
  cursor: pointer;
  box-sizing: border-box;
`;

export default PayverseHeader;
